import _UfpList from './UfpList'

export const UfpList = _UfpList
